import React, {useEffect, useState} from "react";
import {useForceUpdate} from "../../../services/misc.functions";
import {
    homeHippodrome,
    homeHippodromeSubject,
    todayResults,
    todayResultsSubject,
    widgetStatus, widgetStatusSubject
} from "../../../store/misc.store";
import {isMobile} from "../../../App";


export function Results() {
    const forceUpdate = useForceUpdate();
    const [selectedTab, setSelectedTab] = useState<any>(0);
    const [showingRuns, setShowingRuns] = useState<any>(0);
    const [showDetail, setShowDetail] = useState(!isMobile);


    useEffect(() => {

        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            forceUpdate();
        })

        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }

    }, []);

    useEffect(() => {
        let todayResultsSubject_subscription = todayResultsSubject.subscribe((res: any) => {
            forceUpdate();
        })
        return () => {
            todayResultsSubject_subscription.unsubscribe();
        }
    }, []);

    if (isMobile) {
        return <div className={"widget-body"}>

            <table className={"table w-100 widget-table daily-result-table"}>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Atın İsmi</th>
                    <th>Ganyan</th>
                    <th>AGF</th>
                </tr>
                </thead>
                <tbody>
                <tr style={{height: "12px"}}></tr>
                {homeHippodrome?.runs?.map((run: any, runsIndex: number) => {
                    return (<React.Fragment key={`dailyruns-i-${runsIndex}`}>

                        <tr style={{height: '32px'}}>
                            <td className="d-flex justify-content-center align-items-center align-content-center">
                                <p className={"text-small text-bold text-center text-white"}>{run.no}</p>

                            </td>
                            <td className="d-flex  align-items-center align-content-center">
                                {todayResults[homeHippodrome.keyword] != null && todayResults[homeHippodrome.keyword].runsMap[run.no] != null ? <>
                                    {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.no} - {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.name}
                                </> : <>-</>}
                            </td>
                            <td className="d-flex  align-items-center align-content-center">
                                {todayResults[homeHippodrome.keyword] != null && todayResults[homeHippodrome.keyword].runsMap[run.no] != null ? <>
                                    {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.ganyan}
                                </> : <>-</>}
                            </td>
                            <td className="d-flex  align-items-center align-content-center">
                                {todayResults[homeHippodrome.keyword] != null && todayResults[homeHippodrome.keyword].runsMap[run.no] != null ? <>
                                    {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.AGF1 ?? todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.AGF2}
                                </> : <>-</>}
                            </td>

                        </tr>
                    </React.Fragment>)
                })}
                </tbody>
            </table>
        </div>
    } else {
        return <div className={"home-widget"}>
            <div onClick={() => {
                if (isMobile) {
                    setShowDetail((prevShowDetail) => !prevShowDetail);
                }

            }} className={`header ${showDetail ? 'isOpen' : ''}`}>
                <div className={"d-flex align-items-center"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M5.58335 0.749893L5.51591 0.749709C5.28112 0.74876 4.99185 0.747591 4.73698 0.840354C4.32034 0.992002 3.99212 1.32021 3.84048 1.73686C3.78055 1.9015 3.75983 2.08049 3.75292 2.24988L2.60522 2.24988C2.44768 2.24986 2.29421 2.24985 2.16365 2.25876C2.02087 2.2685 1.85158 2.29135 1.67605 2.36406C1.30851 2.5163 1.01649 2.80831 0.864253 3.17586C0.791545 3.35139 0.76869 3.52068 0.758948 3.66346C0.75004 3.79402 0.750055 3.94749 0.750071 4.10502L0.750035 4.60307C0.749712 5.1996 0.749473 5.6426 0.852295 6.02634C1.1297 7.06161 1.93834 7.87026 2.97362 8.14766C3.25903 8.22413 3.57722 8.2436 3.96698 8.24842C4.54288 10.1856 6.20666 11.6544 8.25 11.9467V12.7499H7.91667C6.02969 12.7499 4.5 14.2796 4.5 16.1665C4.5 16.7649 4.98502 17.2499 5.58333 17.2499H12.4167C13.015 17.2499 13.5 16.7649 13.5 16.1665C13.5 14.2796 11.9703 12.7499 10.0833 12.7499H9.75V11.9467C11.7934 11.6545 13.4571 10.1856 14.033 8.24842C14.4228 8.2436 14.741 8.22414 15.0265 8.14766C16.0617 7.87026 16.8704 7.06161 17.1478 6.02634C17.2506 5.6426 17.2504 5.1996 17.25 4.60307L17.25 4.10502C17.25 3.94749 17.25 3.79402 17.2411 3.66346C17.2314 3.52068 17.2085 3.35139 17.1358 3.17586C16.9836 2.80831 16.6916 2.5163 16.324 2.36406C16.1485 2.29135 15.9792 2.2685 15.8364 2.25876C15.7059 2.24985 15.5524 2.24986 15.3949 2.24988L14.2471 2.24988C14.2402 2.08049 14.2195 1.9015 14.1596 1.73686C14.0079 1.32021 13.6797 0.992002 13.263 0.840354C13.0082 0.747591 12.7189 0.74876 12.4841 0.749709L12.4167 0.749893H5.58335ZM3.75002 4.34988C3.75002 4.13986 3.75002 4.03485 3.70914 3.95463C3.67319 3.88407 3.61582 3.82671 3.54526 3.79075C3.46505 3.74988 3.36004 3.74988 3.15002 3.74988L2.80765 3.74988C2.60953 3.74988 2.51046 3.74988 2.4324 3.78813C2.36465 3.82132 2.30639 3.87661 2.26971 3.94254C2.22744 4.0185 2.22243 4.11441 2.21241 4.30623C2.18878 4.75842 2.19119 5.2276 2.30118 5.63811C2.43988 6.15575 2.84421 6.56007 3.36184 6.69877C3.45093 6.72264 3.55687 6.73559 3.75002 6.74248V4.34988ZM14.25 4.35233C14.25 4.14154 14.25 4.03614 14.2911 3.95576C14.3272 3.88506 14.3849 3.82765 14.4557 3.7918C14.5363 3.75105 14.6417 3.75148 14.8525 3.75234L15.1886 3.75371C15.3859 3.75452 15.4846 3.75492 15.5623 3.79324C15.6298 3.82651 15.6877 3.88164 15.7242 3.9474C15.7663 4.02313 15.7714 4.11873 15.7816 4.30995C15.8057 4.7628 15.8052 5.24117 15.6989 5.63811C15.5602 6.15575 15.1559 6.56007 14.6382 6.69877C14.5491 6.72264 14.4432 6.7356 14.25 6.74248V4.35233Z"
                              fill={isMobile && !showDetail ? '#1F3735' : "#ffe700"}></path>
                    </svg>
                    <span className={"text-sm text-white ms-2"}>Sonuçlar</span>
                </div>
                <div></div>
                <div>
                    {isMobile ? <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                             className={` ${showDetail ? 'rotate-svg' : ''}`}>
                            <path d="M4 6L8 10L12 6" stroke={isMobile && !showDetail ? '#1F3735' : "white"}
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"></path>
                        </svg>
                    </> : <div>

                    </div>}
                </div>
            </div>
            {showDetail &&
                <div className={"body"}>
                    {/*{isMobile && <div className={"bg-green w-100 py-2 d-flex px-2"}>*/}
                    {/*    <span onClick={() => {*/}
                    {/*        setSelectedTab(0);*/}
                    {/*    }}*/}
                    {/*          className={`pill-tab text-center left ${selectedTab === 0 ? 'active' : ''}`}>1. 6'lı Ganyan</span>*/}
                    {/*    <span onClick={() => {*/}
                    {/*        setSelectedTab(1);*/}
                    {/*    }}*/}
                    {/*          className={`pill-tab text-center right ${selectedTab === 1 ? 'active' : ''}`}>2. 6'lı Ganyan</span>*/}
                    {/*</div>}*/}
                    <table className={"table w-100 widget-table daily-result-table"}>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Atın İsmi</th>
                            <th>Ganyan</th>
                            <th>AGF</th>
                        </tr>
                        </thead>
                        <tbody>
                        {homeHippodrome?.runs?.map((run: any, runsIndex: number) => {
                            return (<React.Fragment key={`dailyruns-i-${runsIndex}`}>

                                <tr style={{height: '50px'}}>
                                    <td className="d-flex justify-content-center align-items-center align-content-center">
                                        <p className={"text-small text-bold text-center"}>{run.no}.</p>

                                    </td>
                                    <td className="d-flex  align-items-center align-content-center">
                                        {todayResults[homeHippodrome.keyword] != null && todayResults[homeHippodrome.keyword].runsMap[run.no] != null ? <>
                                            {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.no} - {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.name}
                                        </> : <>-</>}
                                    </td>
                                    <td className="d-flex  align-items-center align-content-center">
                                        {todayResults[homeHippodrome.keyword] != null && todayResults[homeHippodrome.keyword].runsMap[run.no] != null ? <>
                                            {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.ganyan}
                                        </> : <>-</>}
                                    </td>
                                    <td className="d-flex  align-items-center align-content-center">
                                        {todayResults[homeHippodrome.keyword] != null && todayResults[homeHippodrome.keyword].runsMap[run.no] != null ? <>
                                            {todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.AGF1 ?? todayResults[homeHippodrome.keyword].runsMap[run.no].winnerHorse.AGF2}
                                        </> : <>-</>}
                                    </td>

                                </tr>
                            </React.Fragment>)
                        })}
                        </tbody>
                    </table>
                </div>
            }
        </div>

    }


}
